import { useAccordionDetails } from 'homepage/application/useAccordionDetails.hook'
import { useLeads } from 'homepage/application/useLeads.hook'
import React, { useMemo } from 'react'
import { useNotificationsModal } from 'notifications/application/useNotificationsModal'
import { MainLayout } from 'shared/ui'
import { ProductsModal } from './components'
import { LayoutWrapper } from './components/Home.styles'
import { LeadsContext } from './components/LeadsContext'
import { Home } from './Home'

const HomeContainer = () => {
  const {
    isLoading,
    hasError,
    leads,
    changeFilters,
    changeSearch,
    changePage,
    page,
    limit,
    filters,
    leadsHomeFin,
    hasFilter,
  } = useLeads()

  const {
    lead,
    error,
    loading,
    handleProposalDetail,
    documentsRequired,
    proposalDetail,
  } = useAccordionDetails()

  const contextValue = useMemo(
    () => ({ isLoading, changeSearch, changeFilters }),
    [isLoading, changeSearch, changeFilters],
  )

  const { isOpen, closeModal, goTo } = useNotificationsModal()

  const homeProps = {
    filters,
    isLoading,
    hasError,
    leads,
    leadsHomeFin,
    page,
    limit,
    changePage,
    leadDetail: {
      handleProposalDetail,
      proposalDetail,
      lead,
      loading,
      error,
      documentsRequired,
    },
    isOpen,
    closeModal,
    goTo,
    hasFilter,
  }

  return (
    <>
      <ProductsModal />
      <LayoutWrapper>
        <MainLayout>
          <LeadsContext.Provider value={contextValue}>
            <Home {...homeProps} />
          </LeadsContext.Provider>
        </MainLayout>
      </LayoutWrapper>
    </>
  )
}

export { HomeContainer }
